export enum RestaurantFilterMode {
  TABLE = 'TABLE',
  DROP_DOWN_SELECT = 'DROP_DOWN_SELECT',
}
